// extracted by mini-css-extract-plugin
export default {"page-shop":"shop_page-shop__px4CL","title":"shop_title__lotgH","ellipsis":"shop_ellipsis__uBN2v"};